import { CaseData } from '../PageContent'

import { CaseImage } from '../CaseImage'
import { CaseVideo } from '../CaseVideo'

interface LayoutProps {
 data: CaseData
 files: {
  type: string
  src: string
 }[]
}

export function Layout3({ data, files }: LayoutProps) {
 return (
  <div className="container">
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseVideo
      videoIndex={0}
      add="main-embed-container"
      video={files[1].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[0].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div
     className="w-full pt-2.5 min-[768px]:pr-1 sm:w-full md:w-1/2 lg:w-1/2"
     data-aos="fade-right"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[2].src}
     />
    </div>
    <div
     className="w-full pt-2.5 min-[768px]:pl-1 sm:w-full md:w-1/2 lg:w-1/2"
     data-aos="fade-left"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[3].src}
     />
    </div>
   </div>
  </div>
 )
}
